<template>
  <div class="card-item" v-if="lottery_type==19">
    <p class="info">
      <span>第{{ item.period || 0 }}期</span>
      <span>{{ item.draw_time || '0000-00-00 00:00' }}</span>
    </p>
    <ul class="lh_num_record">
      <li class="item lh_item" v-for="(record, index) in generateData(item)" :key="'re' + index">
        <span class="numberft" :class="filterNumberColorFt(index,record.number)"
        >{{ record.number }}</span>
        <span class="lh_cha"
              :key="'cha' + index"
        >{{ record.shengxiao }}</span>
      </li>
    </ul>
  </div>
  <div class="card-item" v-else>
    <p class="info">
      <span>第{{ item.period || 0 }}期</span>
      <span>{{ item.draw_time || '0000-00-00 00:00' }}</span>
    </p>
    <ul class="lh_num_record">
      <li class="item lh_item" v-for="(record, index) in generateData(item)" :key="'re' + index">
        <span class="numberlhc" :class="filterNumberColor(record.number)"
        >{{ record.number }}</span>
        <span class="lh_cha"
              :key="'cha' + index"
        >{{ record.shengxiao }}</span>
      </li>

    </ul>
    <div class="tabelBox" :style="{height:`${this.isVisible?'18vw':'0px'}`}">
      <table>
        <tr>
          <td>特码</td>
          <td>生肖</td>
          <td>尾数</td>
          <td>总数</td>
        </tr>
        <tr>
          <td>{{ item.special.daXiao }} {{ item.special.danShuang }} {{ item.special.heShuDaXiao }} {{ item.special.heShuDanShuang }} {{ item.special.jiaYe }} {{ item.special.weiShu }}</td>
          <td>{{ item.sx }}</td>
          <td>{{ item.ws }}</td>
          <td> {{ item.sum.sum }} {{ item.sum.da_xiao }} {{ item.sum.dan_shuang }}</td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import { filterNumber } from "../../../../utils/lhMethods";

export default {
  name: "card-item",
  methods: {
    filterNumberColorFt(index,checkNumber) {
      if(index!=0){
        return 'number-'+checkNumber;
      }
    },
    getRed(data) {
      data = data ? data : "";
      return data.indexOf("大") != -1 || data.indexOf('双') != -1 ? 'red' : '#000000';
    },
    getBlue(data) {
      data = data ? data : "";
      return data.indexOf("龙") != -1 ? 'blue' : '#000000';
    },
    // 过滤当前number的背景图片颜色
    filterNumberColor(checkNumber) {
      const isFilterNumber = filterNumber(checkNumber);
      if (isFilterNumber) {
        return isFilterNumber;
      }
      return '';
    },
    // 前端重组数据
    generateData(item) {
      const splitData = (data, start, end) => data.slice(start, end);
      const numbers = splitData(item.draw_results, 0, 7);
      const shengxiao = splitData(item.draw_results, 7);
      const mapingData = [];
      numbers.forEach((number, index) => {
        mapingData.push({
          number,
          shengxiao: shengxiao[index]
        })
      });
      return mapingData;
    }
  },
  props: {
    thetype: {
      type: [String, Number],
      default: 1
    },
    type: {
      type: [String, Number],
      default: 1
    },
    lottery_type: {
      type: [String, Number],
      default: 0
    },
    item: {
      type: Object,
      default() {
        return {};
      }
    },
    isVisible: Boolean
  }
};
</script>

<style scoped lang="less">
.numberft{
    width: 60px;
    height: 60px;
    display: flex;
    line-height: 25px;
    align-items: center;
    justify-content: center;
    background-size: contain;
    background: #ff9800;
    border-radius: 60px;
    color: #fff;
    font-weight: bold;
  }

  .number-1{
    background: #d5d5d5;
  }

  .number-2{
    background: #69ff2c;
  }

  .number-3{
    background: #ffde42;
  }

  .number-4{
    background: #fd3517;
  }
.card-item {
  color: #606060;
  font-size: 28px;
  background: #fff;
  box-sizing: border-box;
  border-radius: 6px;

  .info {
    width: 100%;
    height: 60px;
    padding: 0 16px;
    display: flex;
    box-sizing: border-box;
    align-items: center;
    justify-content: space-between;
    background-color: #f4f4f4;
  }

  .number-wrap {
    padding: 10px 16px;
    box-sizing: border-box;

    .number {
      margin-right: 10px;
    }
  }
}

table {
  border-bottom: 1px solid #b1afafad;
  border-right: 1px solid #b1afafad;
  margin: 0px auto;
  width: 98%;
}

td {
  border-left: 1px solid #b1afafad;
  padding: 2vw 0px 2vw 1vw;
  color: #010315;
  text-align: center;
}

tr {
  border-top: 1px solid #b1afafad;
}

.tabelBox {
  overflow: hidden;
  transition: height 500ms;
  -webkit-transform: translate3d(0, 0, 0);
  transform: translate3d(0, 0, 0);
}

.lh_num_record {
  display: flex;

  .lh_item {
    display: flex;
    align-items: center;
    margin-left: 0;
    margin-right: 2px;
  }

  .numberlhc {
    width: 60px;
    height: 60px;
    display: flex;
    line-height: 25px;
    align-items: center;
    justify-content: center;
    background-size: contain;
  }

  .number-blue {
    color: #0b0c0c;
    font-weight: bold;
    background: url('../../../../../static/images/lh/back_blue.png') no-repeat center center;
  }

  .number-green {
    color: #0b0c0c;
    font-weight: bold;
    background: url('../../../../../static/images/lh/back_green.png') no-repeat center center;
  }

  .number-red {
    color: #0b0c0c;
    font-weight: bold;
    background: url('../../../../../static/images/lh/back_red.png') no-repeat center center;
  }

  .lh_cha {
    display: inline-block;
    margin-right: 3px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/home/result/card-item/index.vue